export default __webpack_public_path__ + "static/marika-sagiova-ef0946b55bacb34cf5caf22ac1351770.jpg";